import * as types from '../mutation-types'
import api from '../api'
import Vue from 'vue'

const defaultState = () => ({
  invoices:[],
})

const state = {
    ...defaultState()
}

const mutations = {
      [types.INVOICES_RECEIVED](state, payload)
      {
        state.invoices = _.reverse(_.sortBy(payload.invoices, "date"))
      },
}

const actions = {
    fetchInvoices({commit}, customer_id)
    {
      return api.fetch_invoices_of_customer({customer_id:customer_id, params:{customer_id:customer_id, params: {with: 'organization'}}})
                .then((response) => commit(types.INVOICES_RECEIVED, response.data))
    },
}

const getters = {

}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./client/store/modules/invoices.js